import { createStyles, Theme } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    container: {
      display: "flex",
      height: "auto",
      justifyContent: "flex-start",
      alignItems: "center",
      padding: theme.spacing(2),
      paddingRight: 0,
      marginBottom: theme.spacing(3),
      textDecoration: "none",
      color: "#000000",
      position: "relative",
      borderRadius: "20px", 
      backgroundColor: "#fff",

      "&::before": {
        content: '""',
        position: "absolute",
        inset: "-3px",
        borderRadius: "20px",
        background: "linear-gradient(290deg, #4AA9D8, #1779C0)",
        zIndex: "-1",
      },
    },

    image: {
      width: 80,
      height: 80,
      borderRadius: 15,
    },
    data: {
      paddingLeft: '15px',
      fontSize: "clamp(0.8rem, 0.3043rem + 3.4783vw, 0.9rem)",
      [theme.breakpoints.down(768)]: {
        fontSize: "clamp(0.8rem, 0.3043rem + 3.4783vw, 1rem)",
      },

    },
    containerSelected: {
      backgroundImage: "linear-gradient(290deg, #4aa9d8, #004C81)",
      borderRadius: 20,
      color: "white",
      '&:active': {
        backgroundColor: 'transparent',
        border: "1px solid #1779c0",
        borderRadius: 20,
      },
      "& span": {
        color: "white",
      },
    },
  });
